module.exports = __webpack_public_path__ + "media/images/kaiun-4cd2b993e61bf457376164d3731a4cab.png";